@if(!isLoading) {
<div class="Padre">
  <banner-app
    [Fixtop]="''"
    [retroSelected]="true"
    [infoDueno]="true"
    [showPromo]="true"
  ></banner-app>

  <div class="textoArriba">
    <br />
  </div>

  <app-stepper [activeStep]="2"></app-stepper>

  <div class="textoArriba"><br /><br /><br /></div>

  <div class="textoAbajo">
    <br />
  </div>

  <div class="container">
    <div class="row">
      <div class="col-sm-6 col-md-5 offset-md-2 col-lg-6 offset-lg-0">
        <div class="textoArriba">
          <div class="aliniacionTexto">
            <span class="texto1">Falta poco para que compres tu seguro</span
            ><br />
            <span class="textoSeguros"
              >Completa los datos<br />
              restantes del dueño</span
            >
          </div>
          <br /><br />
          <div class="aliniacionImagen">
            <img
              class="styleImage img-responsive"
              src="./assets/img/CelularSeguro.png"
              loading="lazy"
              alt="seguro de moto precio"
            />
          </div>
        </div>
        <div class="textoAbajo">
          <div class="aliniacionTextoMobile">
            <span class="texto1">Falta poco para que compres tu seguro</span
            ><br />
            <span class="textoSeguros"
              >Completa los datos restantes del dueño</span
            >
          </div>
        </div>
      </div>

      <br />
      <div class="col-sm-6 col-md-5 offset-md-2 col-lg-6 offset-lg-0">
        <motos-remaining-data-form
          class="w-100"
          (formSubmit)="Validaciones($event)"
          [cities]="citiesData"
          [countries]="countriesStringData"
          [countriesFullData]="countriesData"
          [numberSelected]="datosGenerales?.Lead?.mobile_phone"
          [dateFromRunt]="datosGenerales?.LeadResponse?.data?.lead?.owner_borndate"
        />
      </div>
    </div>
  </div>

  <app-footer-app class="footer-fixed" />
</div>
}
@else() {
  <sura-mobility-loader />
}